import React, { Component } from 'react';
import classes from './Timeline.css';

function findMatchingTimeUnits(event, timeUnits) {
  //console.log('For event ', event);
  var includesBothUnits = timeUnits.filter(
    (t) =>
      event.startTime.getTime() >= t.startTime.getTime() &&
      event.endTime.getTime() <= t.endTime.getTime()
  );
  //console.log('includesBothUnits:::',includesBothUnits)

  var includesStartTimeUnits = timeUnits.filter(
    (t) =>
      event.startTime.getTime() >= t.startTime.getTime() &&
      event.endTime.getTime() >= t.endTime.getTime() &&
      event.startTime.getTime() <= t.endTime.getTime()
  );
  //console.log('includesStartTimeUnits:::',includesStartTimeUnits);

  var includesEndTimeUnits = timeUnits.filter(
    (t) =>
      event.startTime.getTime() <= t.startTime.getTime() &&
      event.endTime.getTime() <= t.endTime.getTime() &&
      event.endTime.getTime() >= t.startTime.getTime()
  );
  //console.log('includesEndTimeUnits:::',includesEndTimeUnits);

  var spreadAcrossUnits = timeUnits.filter(
    (t) =>
      event.startTime.getTime() <= t.startTime.getTime() &&
      event.endTime.getTime() >= t.endTime.getTime()
  );
  //console.log('spreadAcrossUnits:::',spreadAcrossUnits);

  var results = includesStartTimeUnits
    .concat(includesBothUnits)
    .concat(spreadAcrossUnits)
    .concat(includesEndTimeUnits);
  //console.log("find matching events results:", results);
  results = removeDups(results);
  //console.log("after removing dups, find matching events results:", results);
  return results;
}

function removeDups(a) {
  var seen = new Map();
  a.forEach((item) => {
    seen.set(item.id, item);
  });

  var res = [];
  var it = seen.values();
  while (true) {
    var val = it.next();
    if (val.done) {
      break;
    }
    res.push(val.value);
  }

  return res;
}

class Timebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalTimeUnits: props.timeUnit === 'MINUTES' ? 12 * 60 : 24,
      hours: [],
    };
  }

  componentDidMount() {
    //console.log("Timebar: ", this.props.data.id, "starttime:", this.props.data.startTime);
    var st = new Date(this.props.data.startTime);
    var hours = [];
    for (var i = 0; i < this.state.totalTimeUnits; i++) {
      var et = new Date(st);
      if (this.props.timeUnit === 'MINUTES') {
        et.setMinutes(st.getMinutes() + 2);
      } else {
        et.setHours(st.getHours() + 1);
      }
      var hour = {
        id: i,
        startTime: st,
        endTime: et,
        events: [],
      };
      hours.push(hour);
      st = et;
    }
    var events = this.props.data.events;
    events.forEach((e) => {
      var matchingHours = findMatchingTimeUnits(e, hours);
      matchingHours.forEach((h) => {
        h.class = e.class === 'green' ? classes.Green : classes.Red;
        h.events.push(e);
      });
    });
    var firstConnectionStartTime = this.props.data.connectionStartTime;
    if (
      firstConnectionStartTime.getTime() >= this.props.data.endTime.getTime()
    ) {
      firstConnectionStartTime = this.props.data.endTime;
    }

    if (
      firstConnectionStartTime.getTime() > this.props.data.startTime.getTime()
    ) {
      var greyEvent = {
        startTime: this.props.data.startTime,
        endTime: firstConnectionStartTime,
        class: 'grey',
        title:
          'Last Claimed at ' +
          this.props.data.connectionStartTime.toLocaleString(),
      };
      var greyUnits = findMatchingTimeUnits(greyEvent, hours);
      greyUnits.forEach((g) => {
        //Sometimes connected, disconnected & grey events may reside in the same hour window.
        //For example, our hour window is 7am to 8am
        //There is one connected event at 7:30am and disconnected event at 7:45am.
        //The last claimed date is 7:15am. All these events residing on the same hour window. We should give preference to other events than grey.
        //When we display this scenario in last 7 days or last 30 days,
        //timebar can display only one of the event that occurs on the same hour window.
        //SINCE we handled grey event and insert in the hpour window as a last element, timebar wull not render other events.(one event is displayed in the hour).
        //In this case, our timebar would display only grey events. This is wrong as connected & disconnected events get high priority than grey events.
        //In order to solve this problem, we should not insert grey events if hour window has other events.

        if (g.events.length === 0) {
          g.events.push(greyEvent);
          g.class = classes.Grey;
          g.title = greyEvent.title;
        }
      });
    }
    this.setState({
      hours: hours,
    });
  }

  prepareToolTip(hour) {
    if (hour.events.length === 0) {
      return '';
    }
    /*console.log("Timebar preparetooltip events:", hour.events.map(t => {
   var state = t.topology?t.topology[0].connectionState: "";
   var timestamp = new Date(t.timestamp).toString();
   var endTime = t.endTime != undefined ? t.endTime.toLocaleString(): "";
   return state+" - ["+t.startTime.toLocaleString()+" - "+endTime+" ]";
    }))*/
    // Since multiple events may overlap in an hour, the hour object will store all the events.
    // But when comes to tooltip, the last event would be sufficient.
    var e = hour.events[hour.events.length - 1];
    if (e.class !== undefined && e.class.toLowerCase() === 'grey') {
      return e.title;
    }
    var eventName;
    if (e.class === undefined) {
      eventName = 'Disconnection Event';
    } else if (e.class.toLowerCase() === 'red') {
      eventName = 'Disconnection Event';
    } else if (e.class.toLowerCase() === 'green') {
      eventName = 'Connection Event';
    } else {
      eventName = 'Some Event';
    }
    return (
      eventName + '\n' +
      '[' +
      e.startTime.toLocaleString() +
      ' - ' +
      e.endTime.toLocaleString() +
      ']'
    );
  }

  render() {
    // console.log("rendering timebar::", this.props.data.id);
    //console.log("Timebar.render() hours", this.state.hours);
    //console.log("Timebar.render() totalTimeUnits", this.state.totalTimeUnits);
    var cols = [];
    for (var i = 0; i < this.state.totalTimeUnits; i++) {
      var className = classes.TimebarTd;
      var title = '';
      var hour = this.state.hours[i];
      //console.log("hour", i, hour);
      if (
        hour !== undefined &&
        hour.events !== undefined &&
        hour.events.length > 0
      ) {
        className += ' ' + hour.class + ' + ' + classes.tooltip;

        title = this.prepareToolTip(hour);
      } else {
        //console.log("hour", hour);
        if (hour !== undefined) {
          title =
            'No Events Detected' +
            ' [' +
            hour.startTime.toLocaleString() +
            ' - ' +
            hour.endTime.toLocaleString() +
            ']';
          className += ' ' + classes.Grey + ' + ' + classes.tooltip;
        }
      }
      const showLastTooltipFotUnits =
        this.props.timeUnit === 'MINUTES' ? 39 : 3;
      const lastTooltipclass =
        i >= this.state.totalTimeUnits - 10 - showLastTooltipFotUnits
          ? classes.lasttooltiptext
          : '';
      cols.push(
        <td key={i} id={this.props.data.id + '_' + i} className={className}>
          {' '}
          <div className={classes.tooltip}>
            <span className={classes.tooltiptext + ' ' + lastTooltipclass}>
              {' '}
              {title}{' '}
            </span>{' '}
          </div>
        </td>
      );
    }

    return (
      <div
        id={'Timebar' + this.props.data.id}
        key={this.props.data.id}
        className={classes.Timebar}
      >
        <table className={classes.TimebarTable}>
          <tbody>
            <tr>{cols}</tr>
          </tbody>
        </table>
      </div>
    );
  }
}

class Last24HoursTimeline extends React.Component {
  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = startDate;
    while (currentDate <= stopDate) {
      dateArray.push(new Date(currentDate));
      var cdate = new Date(currentDate);
      cdate.setDate(cdate.getDate() + 1);
      currentDate = cdate;
    }
    return dateArray;
  }

  prepareTimebarsData(props) {
    var endTime = props.data.endTime;
    var startTime = new Date(endTime);
    startTime.setDate(endTime.getDate() - 1);
    //console.log("Last 24 hrs Timeline start time::", startTime, "endtime", endTime);
    /*
    var events = props.data.events;
    if (!events) {
      events = [{
        startTime: startTime,
        endTime: endTime
      }]

    }
    var dates = this.getDates(startTime, endTime);
    var bars = [];
    dates = dates.map(function (startDate, idx) {
      var endDate = new Date(startDate);
      endDate.setHours(startDate.getHours() + 24);

      return {
        id: idx,
        startTime: startDate,
        endTime: endDate,
        events: [],
        connectionStartTime: props.data.connectionStartTime
      };
    });
    events.forEach(e => {
      var matchingDates = findMatchingTimeUnits(e, dates);

      matchingDates.forEach(d => {
        d.events.push(e);
      });
    });
    return dates;


    */
    var dates = [
      {
        id: 0,
        startTime: startTime,
        endTime: endTime,
        events: [],
        connectionStartTime: props.data.connectionStartTime,
      },
    ];

    var events = props.data.events;
    //  console.log("Last  24 Hours events", events);
    if (!events) {
      events = [
        {
          startTime: startTime,
          endTime: endTime,
        },
      ];
    }

    events.forEach((e) => {
      var matchingDates = findMatchingTimeUnits(e, dates);
      // console.log("matching dates", matchingDates);
      matchingDates.forEach((d) => {
        d.events.push(e);
      });
    });
    // console.log("dat0es", dates);
    return dates[0];
  }

  render() {
    // console.log("rendering last 24 hours timeline");
    var bar = this.prepareTimebarsData(this.props);

    return (
      <div className={classes.Timeline}>
        <Timebar data={bar} timeUnit="MINUTES" />
      </div>
    );
  }
}

class Last7DaysTimeline extends React.Component {
  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = startDate;
    while (currentDate < stopDate) {
      dateArray.push(new Date(currentDate));
      var cdate = new Date(currentDate);
      cdate.setDate(cdate.getDate() + 1);
      currentDate = cdate;
    }
    return dateArray;
  }

  prepareTimebarsData(props) {
    var endTime = props.data.endTime;
    var startTime = new Date(endTime);
    startTime.setDate(endTime.getDate() - 7);
    //console.log("Last 7 days Timeline start time::", startTime.toString());
    //console.log("Last 7 days Timeline end time::", endTime.toString());
    var events = props.data.events;
    if (!events) {
      events = [
        {
          startTime: startTime,
          endTime: endTime,
        },
      ];
    }
    var dates = this.getDates(startTime, endTime);
    var bars = [];
    dates = dates.map(function (startDate, idx) {
      var endDate = new Date(startDate);
      endDate.setHours(startDate.getHours() + 24);
      endDate.setMinutes(endDate.getMinutes() - 1);

      return {
        id: idx,
        startTime: startDate,
        endTime: endDate,
        events: [],
        connectionStartTime: props.data.connectionStartTime,
      };
    });
    events.forEach((e) => {
      var matchingDates = findMatchingTimeUnits(e, dates);
      //console.log("matching dates:", JSON.stringify(matchingDates), "event:", JSON.stringify(e));
      matchingDates.forEach((d) => {
        d.events.push(e);
      });
    });
    return dates;
  }

  render() {
    var bars = this.prepareTimebarsData(this.props);
    //console.log("last 7 days timebars:", JSON.stringify(bars));
    var events = this.props.data.events;
    var timebars = bars.map(function (bar, i) {
      return <Timebar data={bar} timeUnit="HOURS" />;
    });

    return <div className={classes.Timeline}>{timebars}</div>;
  }
}

class Last30DaysTimeline extends React.Component {
  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = startDate;
    while (currentDate < stopDate) {
      dateArray.push(new Date(currentDate));
      var cdate = new Date(currentDate);
      cdate.setDate(cdate.getDate() + 1);
      currentDate = cdate;
    }
    return dateArray;
  }

  prepareTimebarsData(props) {
    var endTime = props.data.endTime;
    var startTime = new Date(endTime);
    startTime.setDate(endTime.getDate() - 30);
    //console.log("Last 30 days Timeline start time::", startTime);
    //console.log("Last 30 days Timeline end time::", endTime);

    var dates = this.getDates(startTime, endTime);
    var events = props.data.events;
    if (!events) {
      events = [
        {
          startTime: startTime,
          endTime: endTime,
        },
      ];
    }
    var bars = [];
    dates = dates.map(function (startDate, idx) {
      var endDate = new Date(startDate);
      endDate.setHours(startDate.getHours() + 24);

      return {
        id: idx,
        startTime: startDate,
        endTime: endDate,
        events: [],
        connectionStartTime: props.data.connectionStartTime,
      };
    });
    events.forEach((e) => {
      var matchingDates = findMatchingTimeUnits(e, dates);

      matchingDates.forEach((d) => {
        d.events.push(e);
      });
    });
    return dates;
  }

  render() {
    // console.log("rendering last 30  days timeline");
    var bars = this.prepareTimebarsData(this.props);
    var events = this.props.data.events;
    var timebars = bars.map(function (bar, i) {
      return <Timebar data={bar} timeUnit="HOURS" />;
    });

    return <div className={classes.Timeline}>{timebars}</div>;
  }
}

export { Last7DaysTimeline, Last30DaysTimeline, Last24HoursTimeline };
